// The auth service sends the rep back to the `redirect` URL once the mailbox grant succeeded.
export const MAILBOX_RETURN_PARAM = 'mailbox'
const MAILBOX_RETURN_VALUE = 'allowed'

export const getMailboxReturnUrl = (base: string) => {
  const url = new URL(base, window.location.origin)
  url.searchParams.set(MAILBOX_RETURN_PARAM, MAILBOX_RETURN_VALUE)
  return url.toString()
}

export const isMailboxReturn = (searchParams: URLSearchParams) =>
  searchParams.get(MAILBOX_RETURN_PARAM) === MAILBOX_RETURN_VALUE

// In-app path variant for `navigate`, so the main routes show the "allowed" toast.
export const withMailboxReturn = (path: string) =>
  `${path}${path.includes('?') ? '&' : '?'}${MAILBOX_RETURN_PARAM}=${MAILBOX_RETURN_VALUE}`
